import dayjs from 'dayjs';
import 'dayjs/locale/fa';
import relativeTime from 'dayjs/plugin/relativeTime';
import jalaliday from 'jalaliday';

dayjs.extend(jalaliday);
dayjs.extend(relativeTime);
dayjs.calendar('jalali');
dayjs.locale('fa');
